module.exports = __webpack_public_path__ + "static/media/topsecret.f51f3c3f.png";